import { render, staticRenderFns } from "./TabletMenu.vue?vue&type=template&id=db312b74&scoped=true&lang=pug"
import script from "./TabletMenu.vue?vue&type=script&lang=js"
export * from "./TabletMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db312b74",
  null
  
)

export default component.exports